import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import * as monaco from 'monaco-editor';


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

// Fix for missing `define`
(self as any).MonacoEnvironment = {
  getWorker: function (_moduleId: string, label: string) {
    let workerUrl;
    switch (label) {
      case 'json':
        workerUrl = 'monaco-editor/esm/vs/language/json/json.worker?worker';
        break;
      case 'css':
      case 'scss':
      case 'less':
        workerUrl = 'monaco-editor/esm/vs/language/css/css.worker?worker';
        break;
      case 'html':
      case 'handlebars':
      case 'razor':
        workerUrl = 'monaco-editor/esm/vs/language/html/html.worker?worker';
        break;
      case 'typescript':
      case 'javascript':
        workerUrl = 'monaco-editor/esm/vs/language/typescript/ts.worker?worker';
        break;
      default:
        workerUrl = 'monaco-editor/esm/vs/editor/editor.worker?worker';
    }

    return new Worker(new URL(workerUrl, import.meta.url), {
      type: 'module',
    });
  },
};
